module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="name">\n    '+
((__t=( last_name ))==null?'':_.escape(__t))+
', '+
((__t=( first_name ))==null?'':_.escape(__t))+
'\n</td>\n<td class="voucher">\n    '+
((__t=( joinos_code ))==null?'':_.escape(__t))+
'\n</td>\n<td class="date">\n    '+
((__t=( moment(created).format('DD/MM/YYYY') ))==null?'':_.escape(__t))+
'\n</td>\n<td class="date">\n    '+
((__t=( moment(expires).format('DD/MM/YYYY') ))==null?'':_.escape(__t))+
'\n</td>\n<td class="school_class">\n    '+
((__t=( school_class ))==null?'':_.escape(__t))+
'\n</td>\n<td class="school_year">\n    '+
((__t=( school_year ))==null?'':_.escape(__t))+
'\n</td>\n<td class="school_reg">\n    '+
((__t=( school_reg ))==null?'':_.escape(__t))+
'\n</td>\n<td class="print">\n    <a target="_blank" href="'+
((__t=( letter_url ))==null?'':_.escape(__t))+
'">\n        Print\n    </a>\n</td>\n<td class="cancel">\n    <a class="cancel-button" href="#">\n        Cancel\n    </a>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./joinos_codes/templates/item.html
// module id = 310
// module chunks = 0